import React from 'react';
import { ArrowLeftIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';

export const gradients = {
  insight: 'from-[#B7DFFA] to-[#CFF6D8]',
  mindful: 'from-[#FEE7F3] to-[#B7DFFA]',
  emotion: 'from-[#B7DFFA] to-[#FAE1CD]',
  quote: 'from-[#B7DFFA] to-[#F4DDED]',
  meditation: 'from-[#B7DFFA] to-[#F4DDED]',
  none: '',
};

interface PageHeaderProps {
  title: string;
  url: string;
  type: 'insight' | 'mindful' | 'emotion' | 'quote' | 'meditation' | 'none';
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, url, type }) => {
  return (
    <div className={`flex items-center rounded-lg bg-gradient-to-r ${gradients[type]} p-sh-10`}>
      <Link to={url}>
        <ArrowLeftIcon className="mr-2 h-6 cursor-pointer text-black-100" />
      </Link>
      <span className="font-larken text-sh-sm text-black-100">{title}</span>
    </div>
  );
};

export default PageHeader;
